import {FC, useRef} from 'react'
import Slider, {Settings} from 'react-slick'

import {OfficeCountry, useOfficeLocationsContent} from '@/content/officeLocations'
import {useTranslation} from '@/i18n'
import {CAROUSEL_TRANSITION} from '@/theme/cssTransitions'
import {CONTAINER_PADDING_MOBILE} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {
  MOBILE_MAX_WIDTH,
  MOBILE_SCREENSIZE,
  USER_TABLET_MAX_WIDTH,
} from '@/utils/styles/breakpoints'

import {OfficeLocationButton} from './OfficeLocationButton'
import {OfficeLocationCard} from './OfficeLocationCard'

const settings: Settings = {
  infinite: true,
  speed: CAROUSEL_TRANSITION,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 3000,
  arrows: false,
  responsive: [
    {
      breakpoint: USER_TABLET_MAX_WIDTH,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: MOBILE_MAX_WIDTH,
      settings: {
        slidesToShow: 1,
        centerMode: true,
      },
    },
  ],
}

export const OfficeLocationsCarousel: FC = () => {
  const {t} = useTranslation('page')
  const {offices, previousAriaLabel, nextAriaLabel} = useOfficeLocationsContent()
  const sliderRef = useRef<Slider>(null)

  return (
    <>
      <div className="offices">
        <div className="topics-carousel carousel">
          <Slider {...settings} ref={sliderRef}>
            {Object.keys(offices).map((country) => (
              <OfficeLocationCard key={country} country={country as OfficeCountry} />
            ))}
          </Slider>
        </div>
        <div className="buttons">
          <OfficeLocationButton
            variant="left"
            ariaLabel={t(previousAriaLabel)}
            onClick={() => sliderRef?.current?.slickPrev()}
          />
          <OfficeLocationButton
            ariaLabel={t(nextAriaLabel)}
            onClick={() => sliderRef?.current?.slickNext()}
          />
        </div>
      </div>

      <style jsx>{`
        .buttons {
          display: flex;
          justify-content: center;
          margin-top: ${theme.spacing[5]};
          gap: ${theme.spacing[2]};
        }
      `}</style>
      <style jsx global>{`
        .offices .carousel .slick-slider {
          max-width: inherit;
        }
        .offices .slick-list {
          margin: 0 -${theme.spacing[3]};
        }
        .offices .slick-slide {
          display: flex;
          height: inherit;
          padding: 0 ${theme.spacing[3]};
        }
        .offices .slick-slide > div {
          width: 100%;
        }
        @media ${MOBILE_SCREENSIZE} {
          .offices .slick-list {
            margin: 0 -${CONTAINER_PADDING_MOBILE};
          }
          .offices .slick-slide {
            padding: 0 ${theme.spacing[2]};
          }
        }
      `}</style>
    </>
  )
}
